export const FETCH_CLAIMS_SUCCESS = "FETCH_CLAIMS_SUCCESS";
export const CLEAR_CLAIMS = "CLEAR_CLAIMS";
